module.exports = __webpack_public_path__ + "static/img/project2.cbc8e420.png";